import { inject, Injectable } from '@angular/core';
import { MatSnackBar, type MatSnackBarConfig } from '@angular/material/snack-bar';

import { type SnackBarOptions } from './snack-bar-options.interface';
import { SnackBarComponent } from './snack-bar.component';

@Injectable()
export class SnackBarService {
  readonly #snackBar = inject(MatSnackBar);

  public open(data: SnackBarOptions, config: MatSnackBarConfig = {}) {
    this.#snackBar.openFromComponent(SnackBarComponent, {
      duration: 3000,
      data,
      ...config
    });
  }
}
